/**
 * Os dois avisos da rotação automática: a barra fina no topo e a pílula
 * "a seguir X", que fica NO TOPO, centralizada.
 *
 * No canto inferior direito ela cobria o valor vendido da última divisão da
 * grade — e dado perdido para um controle de navegação é troca ruim. O meio do
 * cabeçalho está vazio, então ela cabe ali sem disputar com nada.
 *
 * Sem eles ninguém entende por que a tela mudou sozinha — e numa sala com 30
 * pessoas olhando, tela que muda sem explicação parece defeito.
 *
 * A pílula é um `<button>`, não um rótulo: o atalho de espaço existe, mas quem
 * está na sala pode não ter teclado à mão. Clicar nela pausa e retoma.
 */

type Props = {
  /** Quanto da visão atual já passou, em porcentagem. */
  progresso: number
  pausado: boolean
  /** Segundos que faltam para a troca. */
  restante: number
  /** Nome da próxima visão, já resolvido ("Lez a Lez", "Visão geral"). */
  nomeSeguinte: string
  aoAlternarPausa: () => void
}

export function BarraRotacao({
  progresso,
  pausado,
  restante,
  nomeSeguinte,
  aoAlternarPausa,
}: Props) {
  /* Largura em `style` porque é VALOR, não layout: é o dado da contagem, como
     no protótipo. O recorte em 0–100 protege de progresso fora da escala
     quando os tempos vêm do cadastro. */
  const largura = `${Math.min(Math.max(progresso, 0), 100)}%`

  return (
    <>
      <div className="barra-rotacao">
        <i style={{ width: largura }} />
      </div>

      <button
        type="button"
        className={pausado ? 'proxima pausado' : 'proxima'}
        onClick={aoAlternarPausa}
        aria-pressed={pausado}
        title={
          pausado
            ? 'Pausado — clique ou espaço para retomar'
            : `Pausar a rotação (espaço) · a seguir ${nomeSeguinte} em ${restante}s`
        }
        aria-label={pausado ? 'Retomar a rotação automática' : 'Pausar a rotação automática'}
      >
        {/* SÓ O ÍCONE (09/10). O texto "a seguir X · Ns" cobria o velocímetro
            da última divisão da grade, e dado perdido para um rótulo de
            navegação é troca ruim. A informação não some: ela vai para o
            `title` e para o `aria-label`, e a barra fina do topo já mostra
            quanto falta para a troca. */}
        <span aria-hidden="true">{pausado ? '▶' : '⏸'}</span>
      </button>
    </>
  )
}
